import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseMutations, firebaseAction } from 'vuexfire'
import Firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/messaging'
import 'firebase/database'

Vue.use(Vuex)

var client = Firebase.initializeApp({
  apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
  authDomain: 'ci-bank-f7673.firebaseapp.com',
  databaseURL: 'https://ci-bank-f7673.firebaseio.com',
  projectId: 'ci-bank-f7673',
  storageBucket: 'ci-bank-f7673.appspot.com',
  messagingSenderId: '931934724781',
}, 'balala').database()
var usersRef = client.ref('users')

const state = {
  /* bot: 'CI-Bank',
  client: {
    apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
    authDomain: 'ci-bank-f7673.firebaseapp.com',
    databaseURL: 'https://ci-bank-f7673.firebaseio.com',
    projectId: 'ci-bank-f7673',
    storageBucket: 'ci-bank-f7673.appspot.com',
    messagingSenderId: '931934724781'
  },
  */
  bot: 'CI-Bank',
  client: {
    apiKey: 'AIzaSyCHU86xU-M2zxWg8lnuJOD9WhdPVhQ5CTM',
    authDomain: 'ci-bank-f7673.firebaseapp.com',
    databaseURL: 'https://ci-bank-f7673.firebaseio.com',
    projectId: 'ci-bank-f7673',
    storageBucket: 'ci-bank-f7673.appspot.com',
    messagingSenderId: '931934724781',
  },
  users: [],
  profile: {},
  firebaseLoginPushKey: null,
  graphData: {},
  graphPieData: {},
  startEndDate: {},
  graphOutdatedStatus: false,
  graphStatus: 'sevenDays',
  listOfAllQuickReplies: [],
  newIntents: {},
  newEditedIntent: {},
  editIntentDetails: {},
  removeIntent: null,
  actionInIntentPage: null,
  asideStatus: false,
}

const mutations = {
  switchBot (state, bot) {
    // mutate state
    state.bot = bot
  },
  writeProfile (state, profile) {
    state.profile = profile
  },
  writeGraphData (state, graphData) {
    state.graphData = graphData
  },
  writeGraphPieData (state, graphPieData) {
    state.graphPieData = graphPieData
  },
  writeStartEndDate (state, startEndDate) {
    state.startEndDate = startEndDate
  },
  writeGraphStatus (state, graphStatus) {
    state.graphStatus = graphStatus
  },
  writeGraphOutdatedStatus (state, graphOutdatedStatus) {
    state.graphOutdatedStatus = graphOutdatedStatus
  },
  writeQuickReplies(state, QuickReplies) {
    state.listOfAllQuickReplies = QuickReplies
  },
  writeNewIntents(state, newIntents) {
    state.newIntents = newIntents
  },
  writeNewEditedIntent(state, newEditedIntent) {
    state.newEditedIntent = newEditedIntent
  },
  writeEditedIntents(state, editIntentDetails) {
    state.editIntentDetails = editIntentDetails
  },
  writeRemoveIntent(state, removeIntent) {
    state.removeIntent = removeIntent
  },
  writeActionInIntentPage(state, actionInIntentPage) {
    state.actionInIntentPage = actionInIntentPage
  },
  writeAsideStatus(state, asideStatus) {
    state.asideStatus = asideStatus
  },
  ...firebaseMutations,
}

const getters = {
  users: state => state.users,
  getGraphStatus: state => state.graphStatus,
  getGraphData: state => state.graphData,
  getStartEndDate: state => state.startEndDate,
  getProfile: state => state.getProfile,
  getListOfAllQuickReplies: state => state.getListOfAllQuickReplies,
  getNewIntents: state => state.getNewIntents,
  getNewEditedIntent: state => state.newEditedIntent,
  getEditIntents: state => state.editIntentDetails,
  getRemoveIntent: state => state.removeIntent,
  getActionInIntentPage: state => state.actionInIntentPage,
}

const actions = {
  setRef: firebaseAction(({
    bindFirebaseRef,
  }) => {
    bindFirebaseRef('users', usersRef)
  }),
  resetRef: firebaseAction(({
    bindFirebaseRef, unbindFirebaseRef,
  }) => {
    var client = Firebase.initializeApp({
      apiKey: 'AIzaSyAtx1NqOWzYQq5slsvK9OTj3DJti8hm4wk',
      authDomain: 'newagent-1faac.firebaseapp.com',
      databaseURL: 'https://newagent-1faac.firebaseio.com',
      messagingSenderId: 293510565120,
      projectId: 'newagent-1faac',
      storageBucket: 'newagent-1faac.appspot.com',
    }, 'balele').database()
    var usersRef = client.ref('users')
    unbindFirebaseRef('users')
    bindFirebaseRef('users', usersRef)
  }),
  changeFBRef({ commit, dispatch }, botName) {
    commit('switchBot', botName)
    dispatch('resetRef')
  },
  setProfile({ commit }, profile) {
    commit('writeProfile', profile)
  },
  setGraphData({ commit }, graphData) {
    commit('writeGraphData', graphData)
  },
  setGraphPieData({ commit }, graphPieData) {
    commit('writeGraphPieData', graphPieData)
  },
  setStartEndDate({ commit }, startEndDate) {
    commit('writeStartEndDate', startEndDate)
  },
  setGraphStatus({ commit }, graphStatus) {
    commit('writeGraphStatus', graphStatus)
  },
  setGraphOutdatedStatus({ commit }, graphOutdatedStatus) {
    commit('writeGraphOutdatedStatus', graphOutdatedStatus)
  },
  setListOfAllQuickReplies({ commit }, QuickReplies) {
    commit('writeQuickReplies', QuickReplies)
  },
  setNewIntents({ commit }, newIntents) {
    commit('writeNewIntents', newIntents)
  },
  setNewEditedIntent({ commit }, newEditedIntent) {
    commit('writeNewEditedIntent', newEditedIntent)
  },
  setEditIntents({ commit }, editIntentDetails) {
    commit('writeEditedIntents', editIntentDetails)
  },
  setRemoveIntent({ commit }, removeIntent) {
    commit('writeRemoveIntent', removeIntent)
  },
  setActionInIntentPage({ commit }, actionInIntentPage) {
    commit('writeActionInIntentPage', actionInIntentPage)
  },
  setAsideStatus({ commit }, asideStatus) {
    document.body.classList.toggle('aside-menu-hidden')
    commit('writeAsideStatus', asideStatus)
  },
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
})



// WEBPACK FOOTER //
// ./src/store/index.js